import {
  MockMap,
  utils,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  assignSeatToJourneyElements,
  retrieveSeatMapsJourneyDriven,
} from './common/seatmap';

const journey = createJourney();
const estimatedDepartureDateTime = new utils.DateTime();
const estimatedArrivalDateTime = new utils.DateTime();
estimatedDepartureDateTime.setHours(estimatedDepartureDateTime.getHours() + 100);
estimatedArrivalDateTime.setHours(estimatedArrivalDateTime.getHours() + 101);
journey.flights[0].checkInFlight.departure.estimatedDateTime = estimatedDepartureDateTime;
journey.flights[0].checkInFlight.arrival.estimatedDateTime = estimatedArrivalDateTime;
const journeys = [journey];

const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);
const seatmap = retrieveSeatMapsJourneyDriven(journeys[0], journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id));

/**
 * OW 1Journey
 * 1ADT
 * Flight ahead
 */
export const ow1Journey1AdtFlightDelayed: MockMap = {
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201), createMockDataWithResponse([{
    ...journeys[0],
    acceptance: AcceptanceRepository.ACCEPTED
  }], 201)],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    )
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
